'use strict';

var propTypes = require('./prop-types.js');
var isDate = require('./is-date.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Check if the two dates passed are equal.
 *
 * @function
 * @param {Date} dateA - A date object.
 * @param {Date} dateB - A date object.
 * @returns {boolean} Returns true if the two dates passed are equal, false otherwise.
 * @example
 * isEqualDate(new Date(), new Date());
 * // => true
 */

var isEqualDate = function isEqualDate(dateA, dateB) {
  return isDate(dateA) && isDate(dateB) && dateA.valueOf() === dateB.valueOf();
};

isEqualDate.HELPER_ID = 'Gearz.JsUtils.isEqualDate';
isEqualDate.returnType = propTypes.boolWithDescription('Returns true if the two dates passed are equal, false otherwise.');
isEqualDate.parameterTypes = {
  dateA: propTypes.instanceOfWithDescription(Date, 'First date to be compared.'),
  dateB: propTypes.instanceOfWithDescription(Date, 'Second date to be compared.')
};
isEqualDate.defaultParameters = {
  dateA: undefined,
  dateB: undefined
};

module.exports = isEqualDate;
